import Guard from 'arg-guard'

/**
 * Definition of a partner and their blocked and added service offerings.
 *
 * @export {PartnerLink} The partner Link.
 * @class PartnerLink
 */
export default class PartnerLink {

    /**
     * Creates a partner with linked service offerings.
     * @param {number} id The id of the partner link.
     * @param {Array<string>} blockList The blocked service offerings.
     * @param {Array<ServiceOffering>} addList The service offerings to add.
     * @memberOf PartnerLink
     */
    constructor(id, blockList = [], addList = []) {
        Guard.throwIf(id, 'id')

        this.id = id
        this.blockList = blockList
        this.addList = addList
    }

    /**
     * Update the available service offerings for the scheme.
     * @param {Array<ServiceOffering>} services The existing service offerings for the scheme.
     * @returns {Array<ServiceOffering>} The updated list.
     */
    availableServices(services) {
        const updated = services
            .filter(service => !this.blockList.includes(service.key))

        return [ ...updated, ...this.addList ]
    }
}
